const Mastercard = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 59 36' fill='none'>
			<ellipse cx='18.1538' cy='18' rx='18.1538' ry='18' fill='#EB001B' />
			<ellipse cx='40.8453' cy='18' rx='18.1538' ry='18' fill='#F79E1B' />
			<path
				d='M29.4991 3.94849C33.6492 7.24726 36.3068 12.3158 36.3068 18C36.3068 23.684 33.6489 28.7516 29.4991 32.0504C25.3493 28.7516 22.6914 23.684 22.6914 18C22.6914 12.3158 25.349 7.24726 29.4991 3.94849Z'
				fill='#FF5F00'
			/>
		</svg>
	);
};

export default Mastercard;
